import { call, put, takeLatest } from "redux-saga/effects";
import {
  ADD_CUSTOMER_REQUEST,
  FETCH_CUSTOMERS_REQUEST,
  UPDATE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_REQUEST,
  FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_ALL_CUSTOMERS_REQUEST,
  RESEND_CUSTOMER_PASSWORD_REQUEST,
} from "../types/customerTypes";
import {
  addCustomerSuccess,
  addCustomerFailure,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  updateCustomerSuccess,
  updateCustomerFailure,
  deleteCustomerSuccess,
  deleteCustomerFailure,
  fetchCustomerDetailsSuccess,
  fetchCustomerDetailsFailure,
  fetchAllCustomersSuccess,
  fetchAllCustomersFailure,
  resendCustomerPasswordSuccess,
  resendCustomerPasswordFailure,
} from "../actions/customerActions";
import axiosInstance from "../../instance/AxiosInstance";

function* handleAddCustomer(action) {
  try {
    const response = yield call(
      axiosInstance.post,
      "/customers/insertcustomer",
      action.payload,
    );

    yield put(addCustomerSuccess(response.data));
  } catch (error) {
    const errorDetails = error.response?.data || {};
    const additionalErrors = errorDetails.additionalErrors || {};
    const message = errorDetails.message || "Failed to add customer";
    yield put(
      addCustomerFailure({
        message,
        additionalErrors,
      }),
    );
  }
}
function* handleFetchCustomers(action) {
  const { payload } = action;
  const params = {};
  if (payload.search) {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
    params.search = payload.search;

    if (payload.search_by && payload.search_by.trim() !== "") {
      params.search_by = payload.search_by;
    }
  } else {
    if (!payload.pagesize || !payload.pageNo) {
      yield put(fetchCustomersFailure("Invalid pagination parameters"));
      return;
    }
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
  }
  try {
    const response = yield call(axiosInstance.get, `/customers/list`, {
      params,
    });
    yield put(fetchCustomersSuccess(response.data));
  } catch (error) {
    yield put(
      fetchCustomersFailure(
        error.response?.data?.message || "Failed to fetch customers",
      ),
    );
  }
}
// fetch all customer (with optional filter params)
function* handleFetchAllCustomers(action) {
  try {
    const params = {};
    const payload = action?.payload || {};
    if (payload.status !== undefined && payload.status !== "")
      params.status = payload.status;
    if (payload.booking_count !== undefined && payload.booking_count !== "")
      params.booking_count = payload.booking_count;
    if (payload.country_id !== undefined && payload.country_id !== "")
      params.country = payload.country_id;
    if (payload.fromDate !== undefined && payload.fromDate !== "")
      params.fromDate = payload.fromDate;
    if (payload.toDate !== undefined && payload.toDate !== "")
      params.toDate = payload.toDate;
    const response = yield call(axiosInstance.get, `/customers/list`, {
      params: Object.keys(params).length ? params : undefined,
    });
    yield put(fetchAllCustomersSuccess(response.data));
  } catch (error) {
    yield put(
      fetchAllCustomersFailure(
        error.response?.data?.message || "Failed to fetch customers",
      ),
    );
  }
}
function* handleUpdateCustomer(action) {
  try {
    const response = yield call(
      axiosInstance.put,
      `customers/updatecustomer/${action.payload.id}`,
      action.payload,
    );

    yield put(updateCustomerSuccess(response.data));
  } catch (error) {
    yield put(
      updateCustomerFailure(
        error.response?.data || "Failed to update customer",
      ),
    );
  }
}
function* handleDeleteCustomer(action) {
  try {
    yield call(
      axiosInstance.delete,
      `/customers/deletecustomer/${action.payload}`,
    );
    yield put(deleteCustomerSuccess(action.payload));
  } catch (error) {
    yield put(
      deleteCustomerFailure(
        error.response?.data?.message || "Failed to delete customer",
      ),
    );
  }
}
function* handleFetchCustomerDetails(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `/customers/getcustomer?customer_id=${action.payload}`,
    );
    if (response.data) {
      yield put(fetchCustomerDetailsSuccess(response.data));
    } else {
      throw new Error("Customer details not found.");
    }
  } catch (error) {
    yield put(
      fetchCustomerDetailsFailure(
        error.response?.data?.message || "Error fetching customer details.",
      ),
    );
  }
}
function* resendCustomerPasswordSaga(action) {
  try {
    const response = yield call(resendCustomerPassword, action.payload);
    yield put(resendCustomerPasswordSuccess(response));
  } catch (error) {
    yield put(resendCustomerPasswordFailure(error));
  }
}
const resendCustomerPassword = async (email) => {
  try {
    const response = await axiosInstance.post(`/auth/resendotp`, { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
export function* watchCustomerActions() {
  yield takeLatest(ADD_CUSTOMER_REQUEST, handleAddCustomer);
  yield takeLatest(FETCH_CUSTOMERS_REQUEST, handleFetchCustomers);
  yield takeLatest(UPDATE_CUSTOMER_REQUEST, handleUpdateCustomer);
  yield takeLatest(DELETE_CUSTOMER_REQUEST, handleDeleteCustomer);
  yield takeLatest(FETCH_CUSTOMER_DETAILS_REQUEST, handleFetchCustomerDetails);
  yield takeLatest(FETCH_ALL_CUSTOMERS_REQUEST, handleFetchAllCustomers);
  yield takeLatest(
    RESEND_CUSTOMER_PASSWORD_REQUEST,
    resendCustomerPasswordSaga,
  );
}
